import YYProgress from './progress'

export default YYProgress